var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"spinner"}),_c('p',[_vm._v(_vm._s(_vm.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }